import { Radio, styled } from '@mui/material';

const FormRadio = styled(Radio)(({ theme }) => ({}));

export default FormRadio;
